var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cemetery-sector-item" }, [
    _c("div", { staticClass: "cemetery-sector-item-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "sector-wrapper",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onToogle.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-link btn-block text-left",
              class: { "cursor-default": !_vm.enableViewOccupation },
              attrs: {
                type: "button",
                "aria-label": `toggle ${_vm.sectorName}`,
              },
            },
            [
              _c("span", { staticClass: "button-wrapper" }, [
                _c("i", {
                  staticClass: "fas",
                  class: [
                    _vm.isExpanded ? "fa-chevron-down" : "fa-chevron-right",
                  ],
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "header" }, [
            _c("span", { staticClass: "sector-name pr-2" }, [
              _vm._v(_vm._s(_vm.sectorNumber ?? _vm.sectorName)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "thin-text" }, [
              _vm._v(_vm._s(_vm.sectorType)),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sector-actions" }, [
        _vm.enableViewDetail
          ? _c(
              "button",
              {
                staticClass: "btn btn-link btn-block text-left",
                attrs: {
                  type: "button",
                  title: _vm.$t(`${_vm.baseTranslateID}.msg.view_form`),
                  "data-toggle": "tooltip-city",
                  "aria-label": `view ${_vm.sectorName}`,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onViewDetail.apply(null, arguments)
                  },
                },
              },
              [_vm._m(0)]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.enableViewOnMap
          ? _c(
              "button",
              {
                staticClass: "btn btn-link btn-block text-left",
                attrs: {
                  type: "button",
                  title: _vm.$t(`${_vm.baseTranslateID}.msg.view_on_map`),
                  "data-toggle": "tooltip-city",
                  "aria-label": `view on map ${_vm.sectorName}`,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onViewOnMap.apply(null, arguments)
                  },
                },
              },
              [_vm._m(1)]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.enableViewOccupation
      ? _c(
          "div",
          { class: { "occupations-invisible": !_vm.isExpanded } },
          [
            _c("CemeterySectorOccupationList", {
              attrs: {
                cemeteryCode: _vm.cemeteryCode,
                sectorId: _vm.sectorId,
                isShow: _vm.isExpanded,
                panelCfg: _vm.panelCfg,
                baseTranslateID: _vm.baseTranslateID,
              },
              on: { highlightFeature: _vm.onViewOnMap },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "button-wrapper" }, [
      _c("i", { staticClass: "far fa-rectangle-list" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "button-wrapper" }, [
      _c("i", { staticClass: "fas fa-location-dot" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }